// extracted by mini-css-extract-plugin
export default {"bodyContainer":"IncomingEmail_bodyContainer_DwMeo"};